module.exports = __webpack_public_path__ + "img/product_7.7e69298.webp";